import Api from './api';

const PATH = '/llm-event-keyword';

const getAllByEventId = async (eventId) => {
  try {
    const response = await Api.get(`${PATH}/${eventId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteById = async (id) => {
  try {
    const response = await Api.delete(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getAllByEventId,
  deleteById
};